import { Info } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import packageJson from './../../../package.json'

export const AppInfo = () => {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="secondary" size="icon" className="cursor-default">
            <Info />
          </Button>
        </TooltipTrigger>
        <TooltipContent className="mx-4">
          <p>Version: {packageJson.version}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
